// src/plugins/fontawesome.js
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

// SOLID ICONS (fas)
import {
  faUser,
  faLock,
  faPlus,
  faCheck,
  faTrash,
  faEdit,
  faEye,
  faEyeSlash,
  faSignOutAlt,
  faHome,
  faBell as fasBell,
  faDoorOpen,
  faCog,
  faBars,
  faCircleXmark,
} from '@fortawesome/free-solid-svg-icons';

// REGULAR ICONS (far)
import {
  faBell as farBell,
  faCalendar,
  faClock,
  faComment,
  faEnvelope,
  faStar,
  faAddressBook,
} from '@fortawesome/free-regular-svg-icons';

// BRAND ICONS (fab)
import {
  faGithub,
  faFacebook,
  faGoogle,
  faLinkedin,
  faTwitter,
  faVuejs,
  faLaravel,
  faNodeJs,
} from '@fortawesome/free-brands-svg-icons';

// Agregar todos los íconos al `library`
library.add(
  // fas
  faUser, faLock, faPlus, faCheck, faTrash, faEdit, faEye, faEyeSlash,
  faSignOutAlt, faHome, fasBell, faDoorOpen, faCog, faBars, faCircleXmark,

  // far
  farBell, faCalendar, faClock, faComment, faEnvelope, faStar, faAddressBook,

  // fab
  faGithub, faFacebook, faGoogle, faLinkedin, faTwitter, faVuejs, faLaravel, faNodeJs
);

// Exportar el componente
export { FontAwesomeIcon };
